import { ExternalLink } from "lucide-react";

import { adaStatUrl, type ChainReference } from "@/lib/adastat";
import { cn } from "@/lib/utils/cn";

// Every chain reference the UI shows opens on AdaStat. [[knowledge-explorer-links]]

interface AdaStatLinkProps {
    kind: ChainReference;
    value: string;
    /** Names the value: its `data-field` for the e2e suite, and the link's accessible name. */
    label: string;
    /**
     * `wrap` breaks a long hash anywhere; `table` keeps one truncated line in a desktop table and
     * wraps on a phone card; `line` always truncates to one line.
     */
    fit?: keyof typeof FIT;
    className?: string;
}

const FIT = {
    wrap: "break-all",
    table: "break-all md:max-w-48 md:truncate md:break-normal",
    line: "truncate",
};

export function AdaStatLink({ kind, value, label, fit = "wrap", className }: AdaStatLinkProps) {
    return (
        <a
            href={adaStatUrl(kind, value)}
            target="_blank"
            rel="noreferrer"
            aria-label={`${label} on AdaStat`}
            title={value}
            className={cn(
                "inline-flex max-w-full items-center gap-1 font-mono text-xs underline-offset-2 hover:underline",
                className,
            )}
        >
            <span data-field={label} className={cn("min-w-0", FIT[fit])}>
                {value}
            </span>
            <ExternalLink aria-hidden className="size-3.5 shrink-0 text-muted-foreground" />
        </a>
    );
}
